import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';

RenderizarBoleto.propTypes = {
    urlPdf: PropTypes.string,
    setEnviarBoleto: PropTypes.func
};

export function RenderizarBoleto({ urlPdf, setEnviarBoleto }) {
    return (
        <div style={{ width: '100%' }}>
            <embed
                data-testid="vendas-pdf"
                type="application/pdf"
                src={urlPdf}
                className="pdf-dialog"
            />
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Button
                    label="Enviar por Email"
                    onClick={() => setEnviarBoleto(true)}
                />
            </div>
        </div>
    );
}
